































































import { ElTable } from "element-ui/types/table";
import { Mixins, Component, Model, Prop, Watch, Emit } from "vue-property-decorator";
import { StandardOption } from "../../../../../../../base/components/system/selectors/mixins";
import { OptionDropDownSelector } from "../../../../../../../base/components/system";
import {
  IConditionalExpressionContent,
  ExpressionOperatorKinds,
  ExpressionLogicalOperatorKinds,
} from "../../../../../../../documaker/domain/format/objects";

@Component({
  components: {
    OptionDropDownSelector,
  },
})
export default class CalculationConditionalExpressionContentSelector extends Mixins() {
  @Model("input")
  contents: IConditionalExpressionContent[];

  @Prop({ type: Function, default: () => "" })
  toSourceTypeName: (row: IConditionalExpressionContent) => string;

  @Prop({ type: Function, default: () => "" })
  toSourceIdentifiableName: (row: IConditionalExpressionContent) => string;

  @Prop({ type: Function, default: () => "" })
  toSourceId: (row: IConditionalExpressionContent) => string;

  @Prop({ type: Function, default: () => "" })
  toValueTypeName: (row: IConditionalExpressionContent) => string;

  @Prop({ type: Function, default: () => "" })
  toValueIdentifiableName: (row: IConditionalExpressionContent) => string;

  @Prop({ type: Function, default: () => "" })
  toValueId: (row: IConditionalExpressionContent) => string;

  $refs!: {
    table: ElTable,
  };

  get openCountOptions(): StandardOption<number>[] {
    return [
      new StandardOption<number>("", 0),
      new StandardOption<number>("(", 1),
    ];
  }

  get closeCountOptions(): StandardOption<number>[] {
    return [
      new StandardOption<number>("", 0),
      new StandardOption<number>(")", 1),
    ];
  }

  get operatorOptions(): StandardOption<ExpressionOperatorKinds>[] {
    return [
      new StandardOption<ExpressionOperatorKinds>("より大きい時", ExpressionOperatorKinds.LessThan),
      new StandardOption<ExpressionOperatorKinds>("以上の時", ExpressionOperatorKinds.LessThanOrEqualTo),
      new StandardOption<ExpressionOperatorKinds>("より小さい時", ExpressionOperatorKinds.GreaterThan),
      new StandardOption<ExpressionOperatorKinds>("以下の時", ExpressionOperatorKinds.GreaterThanOrEqualTo),
      new StandardOption<ExpressionOperatorKinds>("と等しい時", ExpressionOperatorKinds.Euqal),
      new StandardOption<ExpressionOperatorKinds>("以外の時", ExpressionOperatorKinds.NotEqual),
      new StandardOption<ExpressionOperatorKinds>("と一致する時", ExpressionOperatorKinds.Matched),
      new StandardOption<ExpressionOperatorKinds>("と不一致の時", ExpressionOperatorKinds.Unmatched),
    ];
  }

  get logicalOperatorOptions(): StandardOption<ExpressionLogicalOperatorKinds>[] {
    return [
      new StandardOption<ExpressionLogicalOperatorKinds>("", ExpressionLogicalOperatorKinds.None),
      new StandardOption<ExpressionLogicalOperatorKinds>("かつ", ExpressionLogicalOperatorKinds.And),
      new StandardOption<ExpressionLogicalOperatorKinds>("もしくは", ExpressionLogicalOperatorKinds.Or),
    ];
  }

  toIndex(index: number): string {
    if (index === 0) {
      return "1";
    }
    if (this.contents[index - 1].logicalOperator !== ExpressionLogicalOperatorKinds.None) {
      return "";
    }
    return (index - this.contents.slice(0, index).filter(c => c.logicalOperator !== ExpressionLogicalOperatorKinds.None).length + 1).toString();
  }

  @Watch("contents")
  onContentsUpdated(newValue: IConditionalExpressionContent[], oldValue: IConditionalExpressionContent[]) {
    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.table));
  }

  @Emit()
  selectionChange(selection: IConditionalExpressionContent[]): void {}
}
